import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';

@Component({
	selector: 'cv-editable-tabs',
	templateUrl: './editable-tab.component.html',
	styleUrls: ['./editable-tab.component.scss']
})
export class EditableTabComponent implements OnInit, OnDestroy {
	@Input()config;
	public saving = false;
	public selectedTabIndex = 0;

	private atComponentDestroy: Subject<any> = new Subject<any>();

	constructor() { 
		//
	}

	ngOnInit(): void {
		//console.log(this.config)
	}

	ngOnDestroy(): void {
		this.atComponentDestroy.next({});
		this.atComponentDestroy.unsubscribe();
	}
}
